import { Container, Stack } from '@mui/material';
import { ReactElement } from 'react';

import { ArticleDetailDescriptionAccordion } from './components/article-detail-description-accordion';
import { ArticleDetailInformation } from './components/article-detail-information';
import { ArticleDetailPreviewImageDesktop } from './components/article-detail-preview-image-desktop';
import { ArticleDetailSupplierConditions } from './components/article-detail-supplier-conditions';

export const ArticleDetailDesktop = (): ReactElement => {
    return (
        <Container maxWidth="xl" sx={{ mb: 10, mt: 6 }}>
            <Stack direction="row" gap="clamp(48px, 8vw, 144px)">
                <Stack maxWidth={740} gap={2.5} flex="1 1 0">
                    <ArticleDetailPreviewImageDesktop />
                    <ArticleDetailDescriptionAccordion />
                </Stack>

                <Stack flexBasis={615} minWidth={450} gap={8.5}>
                    <ArticleDetailInformation />
                    <ArticleDetailSupplierConditions />
                </Stack>
            </Stack>
        </Container>
    );
};
